module.exports = __webpack_public_path__ + "img/invoiceQuery.f4c09a2e.png";